import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { createAction } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "groupManagement",
  initialState: {
    isGroupData: [],
    isSingleGroupObj: {},
    isGroupModalOpen: false,
    isAdding: false,
    onSuccessMessage : {}
  },

  reducers: {
    // GET Request
    groupObjectNull: (groupManagement, action) => {
      groupManagement.isSingleGroupObj = {};
    },
    allGroupReceived: (groupManagement, action) => {
      groupManagement.isGroupData = action.payload;
    },
    createGroupModalOpened: (groupManagement, action) => {
      groupManagement.isGroupModalOpen = true;
    },
    createGroupModalClosed: (groupManagement, action) => {
      groupManagement.isGroupModalOpen = false;
    },
    groupAdding: (groupManagement, action) => {
      groupManagement.isAdding = true;
    },
    groupAdded: (groupManagement, action) => {
      groupManagement.isAdding = false;
      groupManagement.onSuccessMessage = action.payload;
    },
    updateSingleGroupObject: (groupManagement, action) => {
      groupManagement.isSingleGroupObj = action.payload;
    },
  },
});

export const {
  allGroupReceived,
  updateSingleGroupObject,
  createGroupModalOpened,
  createGroupModalClosed,
  groupAdding,
  groupAdded,
  groupObjectNull,
} = slice.actions;

export default slice.reducer;

// action creator

export const getAllGroupList = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/reminder-group",
    method: "get",
    onSuccess: allGroupReceived.type,
  });

export const addNewGroup = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/reminder-group",
    method: "post",
    data: data,
    onStart: groupAdding.type,
    onSuccess: groupAdded.type,
  });

// Selector
export const getGroupListData = createSelector(
  (state) => state.entities.groupManagement,
  (groupManagement) => groupManagement.isGroupData.data
);

export const getGroupModalOpen = createSelector(
  (state) => state.entities.groupManagement,
  (groupManagement) => groupManagement.isGroupModalOpen
);
/////
export const getCreateLoading = createSelector(
  (state) => state.entities.groupManagement,
  (groupManagement) => groupManagement.isAdding
);
export const getSelectedGroupObject = createSelector(
  (state) => state.entities.groupManagement,
  (groupManagement) => groupManagement.isSingleGroupObj
);
export const getGroupSuccess = createSelector(
  (state) => state.entities.groupManagement,
  (groupManagement) => groupManagement.onSuccessMessage
);